import { useSelector } from 'react-redux';
import { Box, Text } from '@quintoandar-tokko/jopijs';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import styles from './doneEvents.module.scss';
import DoneEventsRow from './DoneEventsRow';
import PerformanceCard from '../PerformanceCard';
import ToolTip from '@/components/ToolTip/ToolTip';
import { DONE_EVENTS } from '../../constants';

export default function DoneEventsContent({ selectedOption }) {
  const { doneEvents } = useSelector((state) => state.DashboardSlice);
  const { options, withoutClosingReason, withoutQualification, notClosed } =
    doneEvents;
  const selectedData = options[selectedOption] ?? { list: [], others: [] };
  const list = selectedData.list ?? [];
  const others = selectedData.others ?? [];

  const othersCount = others.reduce((acc, curr) => acc + curr.count, 0);
  const othersPercentage = others.reduce(
    (acc, curr) => acc + curr.percentage,
    0
  );

  const getTooltipContent = () => {
    const maxVisible = 12;
    const visible = others.slice(0, maxVisible);
    const remaining = others.length - maxVisible;

    return (
      <>
        {visible.map((event) => (
          <Text
            key={event.id ?? event.name}
          >{`${event.name}: ${event.count}`}</Text>
        ))}
        {remaining > 0 && (
          <Text>{`${Trans(translations, 'CountMore', remaining)}...`}</Text>
        )}
      </>
    );
  };

  const renderOthersRow = () => {
    if (others.length === 0) return null;

    return (
      <ToolTip title={getTooltipContent()}>
        <DoneEventsRow
          name={Trans(translations, 'Others')}
          percentage={othersPercentage}
          count={othersCount}
        />
      </ToolTip>
    );
  };

  const renderClosingReasonExtraRows = () => (
    <>
      {withoutClosingReason.count > 0 && (
        <DoneEventsRow
          name={Trans(translations, 'WithoutClosingReason')}
          percentage={withoutClosingReason.percentage}
          count={withoutClosingReason.count}
          useWithoutCategoryTag
        />
      )}
      {notClosed.count > 0 && (
        <DoneEventsRow
          name={Trans(translations, 'NotClosed')}
          percentage={notClosed.percentage}
          count={notClosed.count}
          useWithoutCategoryTag
        />
      )}
    </>
  );

  const renderQualificationExtraRows = () => {
    if (withoutQualification.count === 0) return null;

    return (
      <DoneEventsRow
        name={Trans(translations, 'WithoutQualification')}
        percentage={withoutQualification.percentage}
        count={withoutQualification.count}
        useWithoutCategoryTag
      />
    );
  };

  const renderRows = () => {
    if (selectedOption === DONE_EVENTS.QUALIFICATION) {
      return (
        <>
          {list.map((item) => (
            <DoneEventsRow
              key={item.id ?? item.name}
              name={item.name}
              percentage={item.percentage}
              count={item.count}
              qualification={item.qualification}
            />
          ))}
          {renderQualificationExtraRows()}
        </>
      );
    }

    return (
      <>
        {list.map((item) => (
          <DoneEventsRow
            key={item.name}
            name={item.name}
            percentage={item.percentage}
            count={item.count}
          />
        ))}
        {renderOthersRow()}
        {selectedOption === DONE_EVENTS.CLOSING_REASON &&
          renderClosingReasonExtraRows()}
      </>
    );
  };

  return (
    <PerformanceCard.Content>
      <Box className={styles.rowsWrapper}>{renderRows()}</Box>
    </PerformanceCard.Content>
  );
}
